import { render, staticRenderFns } from "./DreamGoal.vue?vue&type=template&id=80263a90&scoped=true&"
import script from "./DreamGoal.vue?vue&type=script&lang=js&"
export * from "./DreamGoal.vue?vue&type=script&lang=js&"
import style0 from "./DreamGoal.vue?vue&type=style&index=0&id=80263a90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80263a90",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VForm,VProgressLinear,VRow})
